import React from "react";
import { useTranslation } from "react-i18next";
import UserLogoutBar from "../UserLogoutBar";
import "../../styles/components/entryflow/LoadingSessionError.css";

interface LoadingSessionErrorComponentProps {
  errorMessage: string | null;
  onRetry?: () => void;
}

const LoadingSessionErrorComponent: React.FC<LoadingSessionErrorComponentProps> = ({
  errorMessage,
  onRetry,
}) => {
  const { t } = useTranslation();
  
  return (
    <div className="loading-session-error-container">
      <UserLogoutBar />
      <div className="loading-session-error-message">{errorMessage}</div>
      {onRetry && (
        <button className="loading-session-retry-button" onClick={onRetry}>
          {t("loadingSession.retry")}
        </button>
      )}
    </div>
  );
};

const LoadingSessionErrorOnlyComponent: React.FC = () => {
  return <LoadingSessionErrorComponent errorMessage={"This is some error message."} onRetry={() => {}} />;
};

export default LoadingSessionErrorComponent;
export { LoadingSessionErrorOnlyComponent };
